import { render } from "./PersonalDataForm.vue?vue&type=template&id=20c8e953"
import script from "./PersonalDataForm.vue?vue&type=script&lang=js"
export * from "./PersonalDataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__